<template>
    <!-- Modal confirmación de Borrar -->
<div class="modal fade" id="confirmDeleteModal" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteModal" aria-hidden="true" >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" v-t="'confirm_modals.titulo_remover'" ></h5>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body modal-only-text">
              <p v-t="'confirm_modals.confirm_remover'" ></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="material-btn bt_grey close" role="button" data-bs-dismiss="modal" v-t="'boton.cancelar'" aria-label="Close" ></button>
              <a href="#0" class="material-btn bt_red" role="button" @click="confirm()" > {{ $t('boton.remover') }} <i class="far fa-trash-alt"></i></a>
            </div>
          </div>
        </div>
        </div>
</template>

<script>
window.lity_ = null;
export default {
  props:['data_valla','locations'],
  mounted(){ 
     $(document).ready(function() { 
$('#confirmDeleteModal').on('show.bs.modal', function (e) {
  document.getElementById('app').style.position = 'relative';
  });

$("#confirmDeleteModal").on("hidden.bs.modal", function () {
    document.getElementById('app').style.position = 'fixed';
});
});

  },
  methods: {
    confirm() {      
      $('#confirmDeleteModal').modal('hide'); 
      this.$root.$emit("EventRemoveList", _.find(this.locations, { id:this.data_valla.id }));
    setTimeout(() => {
      $('.modal-backdrop').hide();
    }, 500);     
    }
  }
};
</script>
 
<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/confirmModals.json" />
